module.exports = __webpack_public_path__ + "static/img/1@2x (1).35179d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/1@2x (1).png
// module id = hOQU
// module chunks = 1